{
  "toasts": {
    "apiKeyGenerated": "Chave de API gerada com sucesso!",
    "apiKeyGenerateError": "Erro ao gerar chave de API",
    "apiKeyRegenerated": "Chave de API regenerada com sucesso!",
    "apiKeyRegenerateError": "Erro ao regenerar chave de API"
  },
  "page": {
    "title": "Configurações",
    "subtitle": "Ajuste tudo da sua plataforma num só lugar — visual, emails, integrações e segurança."
  },
  "tabs": {
    "overview": "Visão geral",
    "api": "API & Segurança",
    "terms": "Termos de uso",
    "language": "Idioma"
  },
  "actions": {
    "cancel": "Cancelar"
  },
  "hub": {
    "recursos": {
      "title": "Recursos",
      "description": "Ligue ou desligue comunidade, certificados e gamificação para os seus alunos."
    },
    "domains": {
      "title": "Endereços",
      "description": "O endereço por onde seus alunos entram: use o subdomínio pronto ou aponte um domínio seu."
    },
    "branding": {
      "title": "Identidade visual",
      "description": "Logo, imagem da tela de entrada, favicon e as cores da sua marca."
    },
    "emailTemplates": {
      "title": "Templates de email",
      "description": "Edite os emails enviados automaticamente em cada evento (boas-vindas, matrícula, etc)."
    },
    "webhooks": {
      "title": "Webhooks",
      "description": "Notifique sistemas externos quando eventos acontecem (matrícula, pagamento, etc)."
    },
    "surveys": {
      "title": "Pesquisas",
      "description": "Crie pesquisas segmentadas por aluno, curso ou período — com NPS, escalas e mais."
    }
  },
  "overview": {
    "introTitle": "Comece pelo que for mais importante",
    "introDescription": "Esta é a central de configurações da plataforma. Clique em qualquer card abaixo para personalizar uma área específica. Para chaves de API, segurança ou enviar o contrato de termos de uso, use as abas acima.",
    "areas": "Áreas de configuração",
    "quickSettings": "Configurações rápidas",
    "apiDescription": "Chaves de API, tokens JWT e autenticação externa.",
    "termsDescription": "Envie o contrato que o aluno aceita ao entrar."
  },
  "api": {
    "copied": "Copiado para a área de transferência!",
    "explainerTitle": "O que é uma \"chave de API\"?",
    "explainerDescription": "É uma senha especial que permite que <bold>outros sistemas</bold> conversem com sua plataforma (ex: um CRM, um app mobile, uma automação do Zapier). Só gere se souber onde vai usá-la — e nunca compartilhe publicamente.",
    "keyTitle": "Chave de API",
    "keyDescription": "Use esta chave para autenticar chamadas externas à API da plataforma.",
    "saveNowTitle": "Salve esta chave agora!",
    "saveNowDescription": "Esta chave não será exibida novamente. Copie e armazene em um local seguro.",
    "savedConfirm": "Entendi, já salvei",
    "createdAt": "Criada em {{date}}",
    "active": "Ativa",
    "regenerating": "Regenerando...",
    "regenerate": "Regenerar chave",
    "regenerateConfirmTitle": "Regenerar chave de API?",
    "regenerateConfirmDescription": "A chave atual será invalidada imediatamente. Qualquer integração que use a chave antiga deixará de funcionar.",
    "regenerateAction": "Regenerar",
    "generating": "Gerando...",
    "generate": "Gerar chave de API",
    "tokenTitle": "Token de Acesso",
    "tokenDescription": "Seu token JWT atual para chamadas autenticadas à API.",
    "tokenExpiry": "Este token expira em <bold>15 minutos</bold> e é renovado automaticamente. Use no header:",
    "noToken": "Nenhum token disponível. Faça login novamente."
  },
  "terms": {
    "toasts": {
      "updated": "Contrato atualizado com sucesso!",
      "uploadError": "Erro ao enviar contrato",
      "removed": "Contrato removido",
      "removeError": "Erro ao remover contrato",
      "urlError": "Erro ao salvar o link do contrato"
    },
    "explainerTitle": "Contrato que o aluno aceita ao entrar",
    "explainerDescription": "Quando o aluno faz o primeiro login, ele precisa <bold>aceitar os termos</bold>. O arquivo que você enviar aqui é o que vai aparecer para ele ler. Substitua a qualquer momento — a nova versão vale para novos aceites.",
    "cardTitle": "Contrato de Termos e Condições",
    "currentContract": "Contrato atual",
    "openFile": "Abrir arquivo",
    "remove": "Remover",
    "replace": "Substituir",
    "emptyTitle": "Nenhum contrato enviado",
    "emptyDescription": "Enquanto você não enviar um arquivo ou link, seus alunos não passam pela etapa de aceite de termos.",
    "upload": "Enviar contrato",
    "urlLabel": "Link do contrato",
    "urlPlaceholder": "Ou cole o link https do PDF do contrato",
    "saveUrl": "Usar link",
    "hint": "Aceita PDF, DOC e DOCX até 10MB. Se atualizar o arquivo, considere comunicar os alunos que já aceitaram a versão anterior."
  },
  "recursos": {
    "items": {
      "community": {
        "name": "Comunidade",
        "description": "Espaço de conversa entre os alunos, com posts, comentários e eventos."
      },
      "certificates": {
        "name": "Certificados",
        "description": "Emissão de certificado ao concluir um curso."
      },
      "gamification": {
        "name": "Gamificação",
        "description": "Pontos, níveis e ranking entre os alunos."
      },
      "assistant": {
        "name": "Assistente de IA",
        "description": "Monta e sobe cursos na área de membros conversando com você."
      }
    },
    "toasts": {
      "updated": "Recurso atualizado.",
      "updateError": "Não foi possível alterar."
    },
    "loading": "Carregando…",
    "title": "Recursos",
    "subtitle": "O que está disponível para os seus alunos.",
    "outOfPlan": "Fora do plano",
    "turnOn": "Ligar {{name}}",
    "turnOff": "Desligar {{name}}",
    "notInPlan": "Este recurso não está incluído no seu plano. Fale com a Xtreed para liberá-lo.",
    "community": {
      "toasts": {
        "updated": "Endereço da comunidade atualizado.",
        "saveError": "Não foi possível salvar."
      },
      "label": "Endereço da comunidade",
      "save": "Salvar",
      "hint": "Deixe em branco para usar o endereço padrão da Xtreed. Um endereço próprio precisa estar no mesmo domínio da sua área de membros."
    }
  },
  "domains": {
    "status": {
      "pending": "Aguardando DNS",
      "verifying": "Verificando",
      "active": "Ativo",
      "failed": "Não encontrado"
    },
    "toasts": {
      "genericError": "Não foi possível concluir.",
      "created": "Endereço cadastrado. Configure o DNS para ativá-lo.",
      "verified": "Endereço verificado.",
      "txtPending": "O registro TXT ainda não apareceu. O DNS pode levar algumas horas.",
      "primaryUpdated": "Endereço principal atualizado.",
      "removed": "Endereço removido.",
      "copyError": "Não foi possível copiar. Selecione e copie manualmente."
    },
    "title": "Endereços",
    "subtitle": "Por onde seus alunos entram. Você pode usar o subdomínio que já vem pronto ou apontar um domínio seu.",
    "placeholder": "area.suaescola.com.br",
    "newAddress": "Novo endereço",
    "add": "Adicionar",
    "loading": "Carregando endereços…",
    "empty": "Nenhum endereço cadastrado ainda.",
    "primary": "Principal",
    "verify": "Verificar",
    "makePrimary": "Tornar principal",
    "remove": "Remover {{domain}}",
    "dnsInstructions": "Crie estes dois registros no DNS de <bold>{{domain}}</bold>. A propagação costuma levar de minutos a algumas horas.",
    "txtExplanation": "Prova que o domínio é seu",
    "cnameExplanation": "Aponta o tráfego para a plataforma",
    "notFound": "Não encontramos o registro. Confirme se ele foi publicado e verifique de novo — DNS pode demorar a propagar.",
    "copyValue": "Copiar valor do registro {{type}}"
  },
  "language": {
    "title": "Idioma da área",
    "description": "Idioma de toda a área do aluno: menus, botões, mensagens e e-mails.",
    "label": "Idioma da área de membros",
    "hint": "Os alunos não podem trocar o idioma. Só a equipe (admin e instrutor) usa o próprio idioma no painel.",
    "saved": "Idioma padrão atualizado.",
    "saveError": "Não foi possível salvar o idioma padrão."
  }
}
